import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {AuthentService} from "../authent.service";
import {Observable} from "rxjs/Rx";
import {UrlService} from "../url.service";
import {FamiliesService} from "../families.service";
import {Wall} from "../../model/wall";

@Injectable()
export class PhotoWallService extends FamiliesService {

  constructor(private http: Http, private authent: AuthentService, private urlService: UrlService) {
    super();
  }

  getPhotoWall(eventId: number): Observable<Wall> {
    return this.http.get(this.urlService.getPhotoWallUrl(eventId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  getPublicPhotoWall(eventId: number): Observable<Wall> {
    return this.http.get(this.urlService.getPublicPhotoWallUrl(eventId), this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  updatePhotoWall(eventId: number, photoWall: Wall): Observable<Wall> {
    return this.http.put(this.urlService.getPhotoWallUrl(eventId), photoWall, this.authent.getJSONAuthentHeaders())
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteLogo(eventId: number, index: number) {
    return this.http.delete(this.urlService.getPhotoWallLogoAddUrl(eventId, index), this.authent.getAuthentHeaders())
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/photo-wall.service.ts